import api from '@/api';
import localConfig from '@/config';
import { normalizeParamsObject } from 'shared-lib/helpers/formatters';


const types = {
    SAVE_FILTERS: 'SAVE_EMAIL_TEMPLATES_FILTERS',
    RESET_FILTERS: 'RESET_EMAIL_TEMPLATES_FILTERS',
    GET_LAYOUTS_DICT: 'RESET_EMAIL_TEMPLATES_FILTERS',
};

const initialState = {
    data: {
        filters: {
            offset: 0,
            limit: localConfig.defaultListLimit,
            sort: '-created',
        },
    },
    layoutsDict: [],
};

const state = {
    ...initialState,
};


const getters = {
    emailTemplatesFilters: state => state.data.filters,
    layoutsDict: state => state.layoutsDict,
};


const actions = {
    saveEmailTemplatesFilters ({ commit }, payload) {
        commit(types.SAVE_FILTERS, { payload });
    },

    resetEmailTemplatesFilters ({ commit }) {
        commit(types.RESET_FILTERS);
    },

    getLayoutsDict ({ commit }) {
        return api.emailTemplates.layoutsDict()
            .then(({ data }) => commit(types.GET_LAYOUTS_DICT, data.data ));
    },
};


const mutations = {
    [types.SAVE_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);
        state.data = {
            ...state.data,
            filters: { ...payloadNormalized },
        };
    },

    [types.RESET_FILTERS] (state) {
        state.data.filters = { ...initialState.data.filters };
    },

    [types.GET_LAYOUTS_DICT] (state, data) {
        state.layoutsDict = data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
